// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavbarPatient_menu__2XR3S"};